import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Hero from '../components/Hero/Hero';
import About from '../components/About/About';
import Experience from '../components/Experience/Experience';
import Work from '../components/Work/Work';
import GithubProjects from '../components/GithubProjects/GithubProjects';
import Contact from '../components/Contact/Contact';

export default function Home() {
    return (
        <GoogleReCaptchaProvider reCaptchaKey="6LcLznEqAAAAAOywgr7WEWC63KeYyuqFjF0mc21c">
            <div className="page-container homepage">
                <Hero />
                <About />
                <Experience />
                <Work />
                <GithubProjects />
                <Contact />
            </div>
        </GoogleReCaptchaProvider>
    );
}